import { linear, DataPoint } from 'regression';
import { useEffect, useState } from 'react';

interface DataTrend {
  value: number | null;
  direction: 'upward' | 'downward' | null;
  textColor: 'text-primary' | 'text-success' | 'text-danger' | null;
}

interface DataRecieved {
  date_recordednow?: string;
  datesoldnow?: string;
  expense_date? : string;
  date_expense_madenow?: string;
  transaction_time_now?: string;
  net_profit?: number;
  net_sales?: number;
  received_amount?: number;
}

function useDataTrend(datagotten: DataRecieved[]): DataTrend {
  const [dataTrend, setDataTrend] = useState<DataTrend>({
    value: null,
    direction: null,
    textColor: null
  });

  useEffect(() => {
    if (!datagotten) {
      // If datagotten is null or undefined, return null
      setDataTrend({ value: null, direction: null, textColor: null});
      return;
    }

    // Convert dates to Unix timestamps for regression analysis
    const data: DataPoint[] = datagotten.map((item: any) => [
      new Date(item.date_recordednow || item.expense_date ||
        item.datesoldnow ||
        item.date_expense_madenow || item.transaction_time_now).getTime(),
        item.net_sales || 
        item.net_profit ||
        item.net_expenses ||
        item.received_amount
    ]);

    // Perform linear regression to model profit trend over time
    const result = linear(data, { precision: 10 });

    // The slope of the regression line represents the overall trend in profits
    const slope = result.equation[0];

    // Determine whether the profit trend is going up or down
    let direction: 'upward' | 'downward' | null = null;
    let textColor: 'text-primary' | 'text-success' | 'text-danger' | null = null;
    if (slope > 0) {
      direction = 'upward';
      textColor ="text-success";
    } else if (slope < 0) {
      direction = 'downward';
      textColor ="text-danger";
    }
    else if (null) {
      direction = null;
      textColor ="text-primary";
    }

    setDataTrend({ value: slope, direction, textColor });
  }, [datagotten]);

  return dataTrend;
}

export default useDataTrend;
